import { FormikTouched } from 'formik';

export * from './error';

/**
 * Return true if any formik form data was touched
 *
 * @param touchedMap - FormikTouched from formik instancew
 */
export const anyTouched = <Values>(touchedMap: FormikTouched<Values>) => {
    return Object.keys(touchedMap)
        .map((k) => {
            const val = touchedMap[k];
            if (typeof val === 'boolean') {
                return val;
            } else if (Array.isArray(val)) {
                return val.some((i) => i === true);
            } else {
                return !!val;
            }
        })
        .some((i) => i === true);
};
